// extracted by mini-css-extract-plugin
module.exports = {"rating":"Ad-z","numberOfStars":"Bd-z","count":"Cd-z"};